var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 800,
    height: 800
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    cx: 400,
    cy: 400,
    r: 600
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#230046",
    cx: 400,
    cy: 400,
    r: 500
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2f0052",
    cx: 400,
    cy: 400,
    r: 400
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3b075e",
    cx: 400,
    cy: 400,
    r: 300
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#48156a",
    cx: 400,
    cy: 400,
    r: 200
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#552277",
    cx: 400,
    cy: 400,
    r: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.16dc286306daaa8bf80f042629b5a5f8.svg";
export { ForwardRef as ReactComponent };